import styled from 'styled-components';
import DefaultPopup from '@stelecom/ui-react/components/popups/defaultPopup';
import { COLORS, FONTS } from '@stelecom/ui-react/assets/js/constants';

export const ResponsePopup = styled(DefaultPopup)`
  padding: 40px;
  width: calc(100% - 20px) !important;
  max-width: 640px !important;
  gap: 20px;

  @media (max-width: 800px) {
    max-width: 530px !important;
  }
`;

export const Text = styled.h3`
  display: block;
  ${FONTS.H3};
  color: ${COLORS.PINK_BRIGHT};
  margin-top: 20px;
`;

export const Description = styled.p`
  margin-top: 10px;
`;
